var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.social.url,"target":"_blank","rel":"noopener noreferrer"}},[_c('v-icon',[_vm._v(" "+_vm._s(_vm.social.icon)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }